/**
 *
 */
class Menu{

    /**
     *
     * @param options
     */
    constructor(Bulb){

        Utils.debug('Construct menu');

        this.bulb = Bulb;
        this.menuOpen = false;
        this.$menu = $('.mainMenu');
        this.$menuSocials = $('.socialsMenu');
        this.$app = $('#appContent');
        this.$overlay = $('.mainMenu-overlay');
        this.$btn = $('.burger');
        this.$gifs = $('.mainMenu-gifs');
        this.$bg = $('.background')
        this.TL_menu = false;


        this.init();

    }


    /**
     * Init
     */
    init(){
        Utils.debug('Init menu 2');

        var self = this;
        TweenMax.set(self.$menu, {xPercent: -100, alpha: 1});
        TweenMax.set(self.$menuSocials, {yPercent: -100});
        TweenMax.set(self.$gifs, {xPercent: 100, alpha: 1});


        self.$overlay.on('click', function(e){
            self.close();
        });

        self.$btn.on('click', function(e){
            Utils.debug(self);
            e.preventDefault();
            if(!self.menuOpen){
                self.open();
            } else {
                self.close();
            }
        });
    }


    /**
     * Open
     */
    open(){

        Utils.debug('Menu:Open');

        let self = this;
        let gifsWidth = this.$gifs.innerWidth();
        self.menuOpen = true;


        self.$btn.addClass('burger__close');
        TweenMax.set(self.$overlay, {display: 'block', alpha: 1});

        if(self.bulb.device.isTablet || self.bulb.device.isDesktop){
            TweenMax.set(self.$menuSocials, {display: 'block', alpha: 1});
        }


        if(self.bulb.lowVersion){
            //TweenMax.set(self.$bg, {position: 'absolute', y: $(window).scrollTop()});
        }


        if(self.TL_menu) self.TL_menu.pause();
        self.TL_menu = new TimelineMax();
        self.TL_menu.to(self.$app, 0.2, {xPercent: -2, ease: Expo.easeInOut});
        self.TL_menu.add([
            TweenMax.to(self.$menu, 0.5, {xPercent: 0, ease: Expo.easeInOut}),
            TweenMax.to(self.$app, 0.5, {xPercent: 25, ease: Expo.easeInOut})
        ]);
        self.TL_menu.add([
            TweenMax.to(self.$menuSocials, 0.3, {yPercent: 0, ease: Expo.easeInOut}),
            TweenMax.staggerTo(self.$overlay.find('span'), 0.5, {scaleY: 1, ease: Expo.easeInOut}, 0.1)
        ]);

        self.TL_menu.to(self.$gifs, 0.3, {xPercent: 0});
        //TL_menu.play();


    }


    /**
     * Close
     */
    close(){

        Utils.debug('Menu:Close');

        let self = this;
        let y = -Utils.getTranslateY(self.$app);
        let gifsWidth = this.$gifs.innerWidth();
        self.menuOpen = false;

        self.$btn.removeClass('burger__close');

        if(self.TL_menu) self.TL_menu.pause();
        self.TL_menu = new TimelineMax({
            onComplete: function(){
                TweenMax.set(self.$overlay, {display: 'none', alpha: 1});
                TweenMax.set(self.$menuSocials, {display: 'none'});
                TweenMax.set(self.$overlay.find('span'), {scaleY: 0});
                self.changeGif();
                TweenMax.to(self.$app, {'transform': 'none'});
                self.$app.removeAttr('style');


                if(self.bulb.lowVersion){
                    //TweenMax.set(self.$bg, {position: 'absolute', y: 0});
                }

                Utils.debug('Menu:close:end');
            }
        });
        self.TL_menu.to(self.$menuSocials, 0.3, {yPercent:-100, ease: Expo.easeInOut});
        self.TL_menu.to(self.$gifs, 0.3, {xPercent: 100});
        self.TL_menu.add([
            TweenMax.to(self.$overlay, 0.3, {alpha: 0}),
            TweenMax.to(self.$menu, 0.3, {xPercent: -100, ease: Expo.easeInOut}),
            TweenMax.to(self.$app, 0.3, {xPercent: 0, ease: Expo.easeInOut})
        ]);

        //TL_menu.play();
    }


    changeGif(){
        let self = this;
        let data = {
            'action': 'get_menu_gif'
        };
        // We can also pass the url value separately from ajaxurl for front end AJAX implementations
        jQuery.post(adminAjax, data, function(response) {
            self.$gifs.css({
                'background-image': 'url('+response+')'
            })
        });
    }



}


module.exports = Menu;